import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#f3f5f9",
  },
  contentContainer: {
    flex: 1,
    justifyContent: "center",
  },
});

export default styles;
